import { useEffect } from "react";
import { isIOSDevice } from "~/utils/device";

// iOS Safari ignores `overflow: hidden` on html/body once an input is focused
// and the keyboard is open, so the page scrolls behind any open modal. The
// reliable workaround is to pin the body with `position: fixed` while the
// lock is active, then restore the scroll position on release.
export function useIOSScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return;
    if (!isIOSDevice()) return;

    const scrollY = window.scrollY;
    const html = document.documentElement;
    const body = document.body;
    const prev = {
      htmlOverflow: html.style.overflow,
      bodyOverflow: body.style.overflow,
      bodyPosition: body.style.position,
      bodyTop: body.style.top,
      bodyLeft: body.style.left,
      bodyRight: body.style.right,
    };

    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.left = "0";
    body.style.right = "0";

    return () => {
      html.style.overflow = prev.htmlOverflow;
      body.style.overflow = prev.bodyOverflow;
      body.style.position = prev.bodyPosition;
      body.style.top = prev.bodyTop;
      body.style.left = prev.bodyLeft;
      body.style.right = prev.bodyRight;
      window.scrollTo(0, scrollY);
    };
  }, [active]);
}
